<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">Summary & {{ $t("performancereport") }}</div>
      <div class="mt-3 mb-4 border-bottom">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getPerformanceReportFromDate"
                  v-on:click="
                    onPerformanceReportDateHandlerV3Akil({
                      event: null,
                      name: 'fromDate',
                    });
                    onSummaryReportDateHandler({
                      event: null,
                      name: 'fromDate',
                    });
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onPerformanceReportDateHandlerV3Akil({
                      event: $event,
                      name: 'fromDate',
                    });
                    onSummaryReportDateHandler({
                      event: $event,
                      name: 'fromDate',
                    });
                  "
                  ref="programaticOpen"
                  :value="getPerformanceReportFromDate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label :class="getPerformanceReportFromDate ? 'active' : ''">
                  {{ $t("show") }}
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getPerformanceReportToDate"
                  v-on:click="
                    onPerformanceReportDateHandlerV3Akil({
                      event: null,
                      name: 'toDate',
                    });
                    onSummaryReportDateHandler({
                      event: null,
                      name: 'toDate',
                    });
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onPerformanceReportDateHandlerV3Akil({
                      event: $event,
                      name: 'toDate',
                    });
                    onSummaryReportDateHandler({
                      event: $event,
                      name: 'toDate',
                    });
                  "
                  ref="programaticOpen"
                  :value="getPerformanceReportToDate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label :class="getPerformanceReportToDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div
            v-if="!getPerformanceReportsIsCinema"
            class="col-lg-6 col-xl-3 align-self-center mb-3"
          >
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  getPerformanceReportSelectedCinema.length > 0
                    ? 'shift-up'
                    : ''
                "
              >
                {{ $t("select") }}
                {{ $tc("cinema", 1) }}
              </label>
              <b-dropdown
                :text="getPerformanceReportSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="
                    onPerformanceReportDropdownHandler({
                      event: $event,
                      name: 'Cinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex,
                    });
                    onSummaryReportDropdownHandler({
                      event: $event,
                      name: 'isCinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex,
                    });
                    searchCinema = '';
                    onSearchCinema();
                    onSelectCinema(dropdownItem);
                  "
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container mr-2">
              <label :class="selectedTable ? 'shift-up' : ''">
                {{ $t("select") }}
                {{ $tc("Table", 1) }}
              </label>
              <b-dropdown
                :text="selectedTable"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in tablesList"
                  :key="dropdownIndex"
                  @click="selectedTable = dropdownItem"
                  >{{ dropdownItem }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click.prevent="submit">
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="selectedTable === 'Summary Report' || selectedTable === 'Both'"
      >
        <div class="d-flex">
          <div class="section-title mb-3">{{ $t("Summary Report") }}</div>
          <div
            class="col-lg-3 col-xl-2 align-self-end mb-3 ml-auto"
            v-if="getSummariesPDFFileName"
          >
            <a
              v-if="getSummariesPDFFileName"
              :href="BASE_URL + getSummariesPDFFileName"
              target="_blank"
              download
              class="btn-transparent ml-3"
              title="Download as PDF"
              style="color: var(--blue);"
            >
              <img
                src="@/assets/img/icons/download.svg"
                height="20"
                width="20"
              />
              {{ $tc("download") }} PDF
            </a>
            <!-- <a
            v-if="getSummariesPDFFileName" 
            :href="BASE_URL + getSummariesPDFFileName"
            target="_blank"
            download
            class="btn-transparent ml-3"
            title="Download as PDF"
            style="color: var(--blue);"
            ><img
              src="@/assets/img/icons/download.svg"
              height="20"
              width="20"
            />
            {{ $tc("download") }} PDF
          </a> -->
          </div>
        </div>
        <table
          v-if="selected_version == 'v1'"
          class="summary-report-table"
          border="1"
        >
          <tr>
            <td>
              <table class="inner-table">
                <thead>
                  <td colspan="2" class="py-0">
                    <div
                      class="reports-border bg-lightgrey text-center font-weight-bold py-1 mb-3"
                    >
                      {{ $tc("summary") }}
                    </div>
                  </td>
                </thead>
                <tr>
                  <td>{{ $t("total") }} {{ $t("admit") }} (Incl. Compl.):</td>
                  <td>{{ getSummaries.TotalAdmits || "0" }}</td>
                </tr>
                <tr>
                  <td>Total Complimentary Admits:</td>
                  <td>{{ getSummaries.TotalComplimentaryAdmits || "0" }}</td>
                </tr>

                <tr>
                  <td>{{ $t("total") }} {{ $t("transactions") }}:</td>
                  <td>{{ getSummaries.TotalTransactions || "0" }}</td>
                </tr>
                <tr>
                  <td>
                    {{ $t("total") }} {{ $t("available") }}
                    {{ $tc("seat", 1) }} {{ $t("in") }} {{ $tc("Show", 2) }}:
                  </td>
                  <td>{{ getSummaries.TotalSeatsInCinema || "0" }}</td>
                </tr>
                <tr v-if="isIraq">
                  <td>
                    {{ $t("total") }} {{ $tc("seat", 1) }} {{ $t("in") }}
                    {{ $tc("cinema", 2) }}:
                  </td>
                  <td>2,308</td>
                </tr>
                <tr>
                  <td>{{ $t("total") }} {{ $tc("screen", 2) }}:</td>
                  <td>{{ getSummaries.TotalScreens || "0" }}</td>
                </tr>

                <tr>
                  <td>{{ $t("total") }} {{ $t("noof") }} {{ $t("show") }}:</td>
                  <td>{{ getSummaries.TotalNoofShows || "0" }}</td>
                </tr>

                <tr>
                  <td>{{ $t("total") }} {{ $t("revenue") }}:</td>
                  <td>{{ currFormat(getSummaries.TotalRevenue) || "0" }}</td>
                </tr>

                <tr>
                  <td>{{ $t("average") }} {{ $t("show") }}:</td>
                  <td>{{ currFormat(getSummaries.AvgShows) || "0" }}</td>
                </tr>

                <tr>
                  <td>
                    {{ $t("average") }} Seats {{ $t("per") }}
                    {{ $tc("screen", 1) }}:
                  </td>
                  <td>
                    {{ currFormat(getSummaries.AverageSeatPerScreen) || "0" }}
                  </td>
                </tr>
                <tr>
                  <td>
                    {{ $t("average") }} {{ $t("show") }} {{ $t("per") }}
                    {{ $t("per") }} {{ $t("days") }}:
                  </td>
                  <td>
                    {{
                      currFormat(getSummaries.AverageShowsPerDayPerScreen) ||
                        "0"
                    }}
                  </td>
                </tr>
                <tr
                  v-if="Object.keys(getSummariesBoxOffice['IMAX3D']).length > 0"
                >
                  <td>Imax 3D</td>
                  <td>{{ getSummariesBoxOffice["IMAX3D"].qty }}</td>
                </tr>
                <tr
                  v-if="
                    Object.keys(getSummariesBoxOffice['3DOnlyQty']).length > 0
                  "
                >
                  <td>3D Only:</td>
                  <td>{{ getSummariesBoxOffice["3DOnlyQty"].qty }}</td>
                </tr>
              </table>

              <table
                border="1"
                class="mx-auto mb-3"
                style="width:calc(100% - 30px)"
              >
                <thead>
                  <th class="text-center">Channel</th>
                  <th class="text-center">Tickets</th>
                  <th class="text-center">Booking Fees</th>
                  <th class="text-center">Sales</th>
                </thead>
                <tr
                  v-for="(salesData,
                  salesIndex) in getSummaries.salesChannelCounts"
                  :key="salesIndex"
                >
                  <td class="text-left px-2">{{ salesData.bs_source }}</td>
                  <td class="text-right px-2">{{ salesData.sales_count }}</td>
                  <td class="text-right px-2">{{
                    currFormat(salesData.internet_handling_fee)
                  }}</td>
                  <td class="text-right px-2">{{
                    currFormat(salesData.total_sales)
                  }}</td>
                </tr>
              </table>
            </td>
            <td>
              <table class="inner-table">
                <thead>
                  <tr>
                    <td colspan="2" class="py-0">
                      <div
                        class="reports-border bg-lightgrey text-center font-weight-bold py-1 mb-3"
                      >
                        {{ $t("boxoffice") }}
                      </div>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ $t("boxoffice") }} {{ $t("revenue") }}(BOR):</td>
                    <td>
                      {{
                        currFormat(
                          getSummariesBoxOffice.TotalBoxOfficeRevenue
                        ) || "0"
                      }}
                    </td>
                  </tr>

                  <tr v-if="IsTaxSplitShow">
                    <td>{{ $t("VAT") }}:</td>
                    <td>
                      {{ currFormat(getSummariesBoxOffice.VAT) || "0" }}
                    </td>
                  </tr>

                  <tr v-if="IsTaxSplitShow">
                    <td>{{ isStar ? "M-TAX" : $t("GCAM") }}:</td>
                    <td>
                      {{ currFormat(getSummariesBoxOffice.GCAM) || "0" }}
                    </td>
                  </tr>

                  <tr>
                    <td>{{ $t("tax") }}:</td>
                    <td>
                      {{ currFormat(getSummariesBoxOffice.TotalTax) || "0" }}
                    </td>
                  </tr>

                  <tr class="d-none">
                    <td>{{ $t("additionalChanges") }}:</td>
                    <td>
                      {{
                        currFormat(getSummariesBoxOffice.AdditionalCharges) ||
                          "0"
                      }}
                    </td>
                  </tr>

                  <tr>
                    <td>{{ $t("net") }} BOR:</td>
                    <td>
                      {{ currFormat(getSummariesBoxOffice.NetRevenue) || "0" }}
                    </td>
                  </tr>

                  <tr>
                    <td>{{ $t("total") }} {{ $t("transactions") }}:</td>
                    <td>{{ getSummariesBoxOffice.TotalTransaction || "0" }}</td>
                  </tr>

                  <tr>
                    <td>ATP:</td>
                    <td>{{ currFormat(getSummariesBoxOffice.ATP) || "0" }}</td>
                  </tr>

                  <tr>
                    <td>{{ $t("net") }} ATP:</td>
                    <td>
                      {{ currFormat(getSummariesBoxOffice.NetATP) || "0" }}
                    </td>
                  </tr>

                  <tr>
                    <td>{{ $t("occupancy") }} %:</td>
                    <td>
                      {{
                        currFormat(getSummariesBoxOffice.OccupancyRate) || "0"
                      }}
                    </td>
                  </tr>
                  <tr
                    v-if="
                      Object.keys(getSummariesBoxOffice['IMAX3D']).length > 0
                    "
                  >
                    <td>IMAX 3D</td>
                    <td>
                      {{
                        currFormat(
                          getSummariesBoxOffice["IMAX3D"].gross_amount
                        ) || "0"
                      }}
                    </td>
                  </tr>
                  <tr
                    v-if="
                      Object.keys(getSummariesBoxOffice['3DOnlyQty']).length > 0
                    "
                  >
                    <td>3D Only:</td>
                    <td>
                      {{
                        currFormat(
                          getSummariesBoxOffice["3DOnlyQty"].gross_amount
                        ) || "0"
                      }}
                    </td>
                  </tr>
                  <div
                    style="width:125%;"
                    v-if="getSummaries.final_addons_array.length > 0"
                  >
                    <table
                      style="width:calc(100% - 30px)"
                      class="w-100 mx-auto mt-1 mb-1"
                      v-if="getSummaries.final_addons_array.length > 0"
                    >
                      <tr>
                        <td class="p-1">{{ $t("additionalChanges") }}</td>
                        <td class="p-1">Amount</td>
                      </tr>
                      <tr
                        v-for="(addOnitem,
                        addOnsitemIndex) in getSummaries.final_addons_array"
                        :key="addOnsitemIndex"
                      >
                        <td class="p-1 text-left">
                          {{ addOnitem.addons_name }}
                        </td>
                        <td class="p-1 text-right">
                          {{ addOnitem.final_price }}
                        </td>
                      </tr>
                    </table>
                  </div>
                </tbody>
              </table>
            </td>
            <td>
              <table class="inner-table">
                <thead>
                  <tr>
                    <td colspan="2" class="py-0">
                      <div
                        class="reports-border bg-lightgrey text-center font-weight-bold py-1 mb-3"
                      >
                        {{ $t("concession") }}
                      </div>
                    </td>
                  </tr>
                </thead>
                <tr>
                  <td>{{ $t("gross") }} {{ $t("revenue") }}:</td>
                  <td>
                    {{
                      currFormat(
                        getSummariesConcession.GrossConcessionRevenue
                      ) || "0"
                    }}
                  </td>
                </tr>

                <tr>
                  <td>{{ IsTaxSplitShow ? "VAT" : $t("tax") }}:</td>
                  <td>
                    {{
                      currFormat(getSummariesConcession.TaxConcessionRevenue) ||
                        "0"
                    }}
                  </td>
                </tr>

                <tr>
                  <td>
                    {{ $t("concession") }} {{ $t("net") }} {{ $t("revenue") }}:
                  </td>
                  <td>
                    {{
                      currFormat(getSummariesConcession.NetConcessionRevenue) ||
                        "0"
                    }}
                  </td>
                </tr>

                <tr>
                  <td>
                    {{ $t("cost") }} Of {{ $t("goods") }} {{ $t("sold") }}:
                  </td>
                  <td>
                    {{ currFormat(getSummariesConcession.CostOfGoods) || "0" }}
                  </td>
                </tr>

                <tr>
                  <td>
                    {{ $t("gross") }} {{ $t("spend") }} {{ $t("per") }}
                    {{ $t("head") }}:
                  </td>
                  <td>
                    {{
                      currFormat(getSummariesConcession.GrossSpendPerHead) ||
                        "0"
                    }}
                  </td>
                </tr>

                <tr>
                  <td>{{ $t("transactions") }}:</td>
                  <td>
                    {{
                      getSummariesConcession.NumberOfConcessionsTransactions ||
                        "0"
                    }}
                  </td>
                </tr>

                <tr>
                  <td>
                    {{ $t("admission") }} {{ $t("strike") }} {{ $t("rate") }}:
                  </td>
                  <td>
                    {{
                      currFormat(getSummariesConcession.AdmissionStrikeRate) ||
                        "0"
                    }}
                  </td>
                </tr>

                <tr>
                  <td>
                    {{ $t("average") }} {{ $t("value") }} {{ $t("per") }}
                    {{ $t("transactions") }}:
                  </td>
                  <td>
                    {{
                      currFormat(
                        getSummariesConcession.AverageValuePerTransaction
                      ) || "0"
                    }}
                  </td>
                </tr>

                <tr>
                  <td>{{ $t("no") }} of {{ $t("items") }} {{ $t("sold") }}:</td>
                  <td>
                    {{ getSummariesConcession.NoOfItemsSold || "0" }}
                  </td>
                </tr>
                <tr>
                  <td>
                    {{ $t("quantity") }} of {{ $t("items") }} {{ $t("sold") }}:
                  </td>
                  <td>
                    {{ getSummariesConcession.QuantityOfItemsSold || "0" }}
                  </td>
                </tr>
              </table>

              <table
                style="width:calc(100% - 30px)"
                border="1"
                class="mx-auto mb-3"
                v-show="false"
                v-if="getSummariesConcession.TopFiveItemsSold.length > 0"
              >
                <tr>
                  <td class="p-1">{{ $t("items") }} {{ $t("name") }}</td>
                  <td class="p-1">Qty {{ $t("sold") }}</td>
                  <td class="p-1">{{ $t("gross") }} {{ $t("revenue") }}</td>
                  <td class="p-1">{{ $t("profit") }} {{ $t("margin") }}</td>
                </tr>
                <tr
                  v-for="(items,
                  itemIndex) in getSummariesConcession.TopFiveItemsSold"
                  :key="itemIndex"
                >
                  <td class="p-1 text-left">{{ items.recipe_name }}</td>
                  <td class="p-1 text-right">{{ items.count }}</td>
                  <td class="p-1 text-right">
                    {{ currFormat(items.fp_total_amount * items.count) }}
                  </td>
                  <td class="p-1 text-left">
                    {{
                      currFormat(
                        items.fp_total_amount * items.count -
                          items.fp_cost_of_item * items.count
                      )
                    }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <table class="inner-table d-none">
                <thead>
                  <tr>
                    <td colspan="2" class="py-0">
                      <div
                        class="reports-border bg-lightgrey text-center font-weight-bold py-1 mb-3"
                      >
                        {{ $t("concession") }} {{ $t("profit") }}
                      </div>
                    </td>
                  </tr>
                </thead>
                <tr>
                  <td>
                    {{ $t("profit") }} At {{ $t("standard") }} {{ $t("cost") }}:
                  </td>
                  <td>
                    {{
                      currFormat(
                        getSummariesConcessionProfit.ProfitAtStandardCost
                      ) || "0"
                    }}
                  </td>
                </tr>

                <tr>
                  <td>{{ $t("average") }} {{ $t("profit") }}:</td>
                  <td>
                    {{
                      currFormat(getSummariesConcessionProfit.AverageProfit) ||
                        "0"
                    }}
                  </td>
                </tr>

                <tr>
                  <td>
                    {{ $t("average") }} {{ $t("profit") }} {{ $t("per") }}
                    {{ $t("items") }}:
                  </td>
                  <td>
                    {{
                      currFormat(
                        getSummariesConcessionProfit.AverageProfitPerItem
                      ) || "0"
                    }}
                  </td>
                </tr>

                <tr>
                  <td>{{ $t("profit") }} {{ $t("per") }} {{ $t("head") }}:</td>
                  <td>
                    {{
                      currFormat(getSummariesConcessionProfit.ProfitPerHead) ||
                        "0"
                    }}
                  </td>
                </tr>

                <tr>
                  <td>
                    {{ $tc("price", 1) }} {{ $t("per") }}
                    {{ $t("transactions") }}:
                  </td>
                  <td>
                    {{
                      currFormat(
                        getSummariesConcessionProfit.PricePerTransaction
                      ) || "0"
                    }}
                  </td>
                </tr>
              </table>
            </td>
            <!-- <td>
      <table class="inner-table">
        <thead>
          <tr>
            <td colspan="2" class="py-0">
              <div
              class="reports-border bg-lightgrey text-center font-weight-bold py-1 mb-3"
              >Miscellaneous</div>
            </td>
          </tr>
        </thead>
        <tr>
          <td>Total Admits:</td>
          <td>4,170</td>
        </tr>
      </table>
          </td>-->
          </tr>
        </table>
      </div>

      <hr />

      <div
        v-if="
          selectedTable === 'Performance Report' || selectedTable === 'Both'
        "
      >
        <div class="section-title">Performance Report</div>
        <div
          class="d-flex justify-content-end mt-1 align-items-center"
          v-if="getPerformanceReportList.length > 0"
        >
          <div>{{ $t("download") }} as:</div>
          <a
            v-if="getPerformancePdfFileName"
            :href="BASE_URL + getPerformancePdfFileName"
            target="_blank"
            download
            title="Download as PDF"
          >
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>

          <a href="#" @click="excelDownload()" title="Download as Excel">
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>

        <div class="table-scroll" v-if="getPerformanceReportList.length === 0">
          <table class="performance-report-table" border="1">
            <thead>
              <tr>
                <td colspan="2"></td>
                <td colspan="3">{{ $t("audience") }}</td>
                <td colspan="5">{{ $t("revenue") }}</td>
                <td colspan="2">ATP</td>
              </tr>
              <tr>
                <td>{{ $t("film") }}</td>
                <td>{{ $t("noof") }} {{ $t("show") }}</td>
                <td>{{ $t("admits") }}</td>
                <td>{{ $tc("available", 1) }} {{ $t("capacity") }}</td>
                <td>{{ $t("occupancy") }} %</td>
                <td>BOR</td>
                <!-- New -->
                <td>Offers / Vouchers</td>
                <!-- New -->
                <td>{{ $t("tax") }}</td>
                <td>{{ $t("service") }} {{ $t("charge") }}</td>
                <td>Nett BOR</td>
                <td>BOR ATP</td>
                <td>{{ $t("net") }} ATP</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="12">
                  <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-scroll" v-if="getPerformanceReportList.length > 0">
          <table class="performance-report-table" border="1">
            <thead>
              <tr>
                <td colspan="2"></td>
                <td colspan="3">Audience</td>
                <td colspan="4">
                  {{ $t("revenue") }}
                </td>
                <td colspan="2">ATP</td>
              </tr>
              <tr>
                <td>{{ $t("film") }}</td>
                <td>{{ $t("noof") }} {{ $t("show") }}</td>
                <td>{{ $t("admits") }}</td>
                <td>{{ $tc("available", 1) }} {{ $t("capacity") }}</td>
                <td>{{ $t("occupancy") }} %</td>
                <td>BOR</td>
                <!-- New -->
                <!-- <td
                  v-for="(Charge,
                  ChargeIndex) in getPerformanceReportChargeList"
                  :key="ChargeIndex"
                >
                  <span>{{ Charge.ct_name }}</span>
                </td> -->
                <td>VAT</td>
                <td>{{ isStar ? "M-TAX" : "GCAM" }}</td>
                <!-- <td>CGST</td>
            <td>SGST</td>-->
                <td>Nett BOR</td>
                <td>BOR ATP</td>
                <td>Net ATP</td>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="(PerformanceReportList,
                PerformanceReportListIndex) in getPerformanceReportList"
                :key="PerformanceReportListIndex"
              >
                <td class="text-left">
                  <div>{{ PerformanceReportList.movie_name }}</div>
                </td>
                <td class="text-right">
                  <div>&nbsp;</div>
                  <div>{{ PerformanceReportList.no_of_show }}</div>
                  <!-- <div>8</div>
              <div>12</div>-->
                </td>
                <td class="text-right">
                  <div>&nbsp;</div>
                  <div>{{ PerformanceReportList.admits }}</div>
                </td>
                <td class="text-right">
                  <div>&nbsp;</div>
                  <div>{{ PerformanceReportList.capacity_total }}</div>
                </td>
                <td class="text-right">
                  <div>&nbsp;</div>

                  <div>
                    {{
                      PerformanceReportList.admits &&
                      PerformanceReportList.capacity_total
                        ? currFormat(
                            ((parseFloat(PerformanceReportList.admits) /
                              parseFloat(
                                PerformanceReportList.capacity_total
                              )) *
                              10000) /
                              100
                          )
                        : 0
                    }}
                  </div>
                </td>
                <td class="text-right">
                  <div>&nbsp;</div>
                  <div>
                    {{ currFormat(PerformanceReportList.gross_amount) }}
                  </div>
                </td>
                <!-- New -->
                <td class="text-right">
                  {{ currFormat(PerformanceReportList["VAT"]) }}
                </td>
                <td class="text-right">
                  {{
                    isStar
                      ? currFormat(
                          PerformanceReportList["M-TAX"]
                            ? PerformanceReportList["M-TAX"]
                            : "0"
                        )
                      : currFormat(
                          PerformanceReportList["GCAM"]
                            ? PerformanceReportList["GCAM"]
                            : "0"
                        )
                  }}
                </td>

                <!-- <td
                  class="text-right"
                  v-for="(ChargeItem,
                  ChargeIndex) in getPerformanceReportChargeList"
                  :key="
                    ChargeIndex + ChargeItem.ChargeName + ChargeItem.ct_name
                  "
                >
                  <div>&nbsp;</div>
                  <div>
                    {{
                      PerformanceReportList[ChargeItem.ct_name]
                        ? ChargeItem.pas_is_rebate &&
                          ChargeItem.pas_is_rebate === "Y"
                          ? currFormat(
                              PerformanceReportList[ChargeItem.ct_name]
                            )
                          : currFormat(
                              PerformanceReportList[ChargeItem.ct_name]
                            ) || "-"
                        : "_"
                    }}
                  </div>
                </td> -->

                <!-- <td>0</td>
            <td>0.00</td>-->
                <td class="text-right">
                  <div>&nbsp;</div>
                  <div>
                    {{
                      PerformanceReportList.net_amount
                        ? currFormat(PerformanceReportList.net_amount)
                        : 0
                    }}
                  </div>
                </td>
                <td class="text-right">
                  <div>&nbsp;</div>
                  <div>
                    {{
                      PerformanceReportList.gross_amount &&
                      PerformanceReportList.admits
                        ? currFormat(
                            PerformanceReportList.gross_amount /
                              PerformanceReportList.admits
                          ) || "-"
                        : 0
                    }}
                  </div>
                </td>
                <td class="text-right">
                  <div>&nbsp;</div>
                  <div>
                    {{
                      PerformanceReportList.net_amount &&
                      PerformanceReportList.admits
                        ? currFormat(
                            PerformanceReportList.net_amount /
                              PerformanceReportList.admits
                          )
                        : 0
                    }}
                  </div>
                </td>
              </tr>
              <tr class="bg-lightgrey font-weight-bold">
                <td>Grand Total</td>
                <td class="text-right">
                  {{
                    getPerformanceReportList.reduce(
                      (acc, { no_of_show }) => acc + no_of_show,
                      0
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    getPerformanceReportList.reduce(
                      (acc, { admits }) => acc + admits,
                      0
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    getPerformanceReportList.reduce(
                      (acc, { capacity_total }) => acc + capacity_total,
                      0
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      ((getPerformanceReportList.reduce(
                        (acc, { admits }) => acc + admits,
                        0
                      ) /
                        getPerformanceReportList.reduce(
                          (acc, { capacity_total }) => acc + capacity_total,
                          0
                        )) *
                        10000) /
                        100
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      getPerformanceReportList.reduce(
                        (acc, { gross_amount }) => acc + gross_amount,
                        0
                      )
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      getPerformanceReportList.reduce(
                        (acc, { VAT }) => acc + VAT,
                        0
                      )
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    isStar
                      ? currFormat(
                          getPerformanceReportList.reduce(
                            (acc, obj) => acc + +parseFloat(obj["M-TAX"]) || 0,
                            0
                          )
                        )
                      : currFormat(
                          getPerformanceReportList.reduce(
                            (acc, { GCAM }) => acc + GCAM,
                            0
                          )
                        )
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      getPerformanceReportList.reduce(
                        (acc, { net_amount }) => acc + net_amount,
                        0
                      )
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      getPerformanceReportList.reduce(
                        (acc, { gross_amount }) => acc + gross_amount,
                        0
                      ) /
                        getPerformanceReportList.reduce(
                          (acc, { admits }) => acc + admits,
                          0
                        )
                    )
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      getPerformanceReportList.reduce(
                        (acc, { net_amount }) => acc + net_amount,
                        0
                      ) /
                        getPerformanceReportList.reduce(
                          (acc, { admits }) => acc + admits,
                          0
                        )
                    )
                  }}
                </td>
              </tr>
              <!-- <tr>
            <td></td>
            <td>
              <strong>24</strong>
            </td>
            <td>
              <strong>81</strong>
            </td>
            <td>
              <strong>2,1488</strong>
            </td>
            <td></td>
            <td>
              <strong>4,578</strong>
            </td>
            <td>
              <strong>218</strong>
            </td>
            <td>
              <strong>0.00</strong>
            </td>
            <td>
              <strong>4,360</strong>
            </td>
            <td>
              <strong>56.0</strong>
            </td>
            <td>
              <strong>53.3</strong>
            </td>
          </tr>-->
            </tbody>
          </table>

          <br />
          <br />
          <h5 class="section-title    ">Concession Sale Analysis</h5>
          <div
            class="d-flex justify-content-end mt-1 align-items-center"
            v-if="getPerformanceReportList.length > 0"
          >
            <div>{{ $t("download") }} as:</div>
            <a
              v-if="getPerformancePdfFileName"
              :href="BASE_URL + getPerformancePdfFileName"
              target="_blank"
              download
              title="Download as PDF"
            >
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>

            <a
              href="#"
              @click="concessionExcelDownload()"
              title="Download as Excel"
            >
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </a>
          </div>
          <table class="concession-analysis-table">
            <thead>
              <tr>
                <th colspan="1" style="width:20%">Item</th>
                <th colspan="4">Units</th>
                <th colspan="3">Per 100 Patrons</th>
                <th colspan="4">Value</th>
              </tr>

              <tr>
                <th></th>
                <th>Qty Sold</th>
                <th>Net Price</th>
                <th>Std Profit</th>
                <th>Std Profit %</th>
                <th>Qty</th>
                <th>Sale</th>
                <th>Profit</th>
                <th>Net Sale</th>
                <th>Sale Mix %</th>
                <th>Net Profit</th>
                <th>Profit Mix %</th>
              </tr>
            </thead>
            <tbody class="border-bottom border-dark">
              <!-- CREATE THIS TR ONLY FIRST TIME -->
              <tr>
                <td>
                  <strong>F&B</strong>
                </td>
                <td colspan="11"></td>
              </tr>
            </tbody>
            <tbody
              class="border-bottom border-dark"
              :class="'___' + PerformanceConcessionReports.fc_category"
              v-for="(PerformanceConcessionReports,
              PerformanceConcessionReportsIndex) in getPerformanceConcessionReportsListSort"
              :key="PerformanceConcessionReportsIndex"
            >
              <tr class="bg-lightgrey font-weight-bold">
                <td>{{ PerformanceConcessionReports.fc_category }}</td>
              </tr>
              <tr
                v-for="(SingleItem,
                SingleIndex) in PerformanceConcessionReports.FoodCategory"
                :key="SingleIndex"
              >
                <td>
                  <p v-if="SingleIndex === 0"></p>
                  {{ SingleItem.item_name }}
                </td>
                <td class="text-right">
                  <p v-if="SingleIndex === 0">&nbsp;</p>
                  {{ SingleItem.fst_quantity }}
                </td>
                <td class="text-right">
                  {{
                    SingleItem["net_price"]
                      ? currFormat(SingleItem.net_price)
                      : ""
                  }}
                </td>
                <td class="text-right">
                  {{
                    SingleItem["std_profit"]
                      ? currFormat(SingleItem.std_profit)
                      : ""
                  }}
                </td>
                <td class="text-right">
                  {{
                    SingleItem["std_profit"] && SingleItem["net_price"]
                      ? currFormat(
                          (SingleItem.std_profit / SingleItem.net_price) * 100
                        )
                      : ""
                  }}
                </td>
                <td class="text-right">
                  {{
                    parseFloat(
                      (SingleItem.fst_quantity * 100) / getSummaries.TotalAdmits
                    ).toFixed(MIN_FRACTION_DIGITS) || 0
                  }}
                </td>

                <td class="text-right">
                  {{
                    (
                      (SingleItem["net_price"] *
                        (SingleItem.fst_quantity * 100)) /
                      getSummaries.TotalAdmits
                    ).toFixed(MIN_FRACTION_DIGITS)
                  }}
                </td>
                <td class="text-right">
                  {{
                    (
                      SingleItem["std_profit"] *
                      ((SingleItem.fst_quantity * 100) /
                        getSummaries.TotalAdmits)
                    ).toFixed(MIN_FRACTION_DIGITS)
                  }}
                </td>
                <td class="text-right">
                  {{
                    SingleItem["net_sales"]
                      ? currFormat(SingleItem.net_sales)
                      : ""
                  }}
                </td>
                <td class="text-right">
                  {{
                    SingleItem["net_sales"] && SingleItem["total_net_sales"]
                      ? currFormat(
                          (SingleItem.net_sales / SingleItem.total_net_sales) *
                            100
                        )
                      : ""
                  }}
                </td>
                <td class="text-right">
                  {{
                    SingleItem["net_profit"]
                      ? currFormat(SingleItem.net_profit)
                      : ""
                  }}
                </td>
                <td class="text-right">
                  {{
                    SingleItem["net_profit"] && SingleItem["total_std_profit"]
                      ? currFormat(
                          (SingleItem.net_profit /
                            SingleItem.total_std_profit) *
                            100
                        )
                      : ""
                  }}
                </td>
              </tr>
              <tr
                :key="PerformanceConcessionReportsIndex + 'CategoryTotal'"
                class="bg-lightgrey font-weight-bold"
              >
                <td>Total:</td>
                <td class="text-right">
                  {{
                    PerformanceConcessionReports.FoodCategory.reduce(
                      (acc, { fst_quantity }) => {
                        return acc + fst_quantity;
                      },
                      0
                    ).toFixed(MIN_FRACTION_DIGITS) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      PerformanceConcessionReports.FoodCategory.reduce(
                        (acc, { net_price }) => {
                          return acc + net_price;
                        },
                        0
                      ) / PerformanceConcessionReports.FoodCategory.length
                    ) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      PerformanceConcessionReports.FoodCategory.reduce(
                        (acc, { std_profit }) => {
                          return acc + std_profit;
                        },
                        0
                      ) / PerformanceConcessionReports.FoodCategory.length
                    ) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      PerformanceConcessionReports.FoodCategory.reduce(
                        (acc, { std_profit, net_price }) => {
                          return acc + (std_profit / net_price) * 100;
                        },
                        0
                      ) / PerformanceConcessionReports.FoodCategory.length
                    ) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    PerformanceConcessionReports.FoodCategory.reduce(
                      (acc, { fst_quantity }) => {
                        return (
                          acc + (fst_quantity * 100) / getSummaries.TotalAdmits
                        );
                      },
                      0
                    ).toFixed(MIN_FRACTION_DIGITS) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    PerformanceConcessionReports.FoodCategory.reduce(
                      (acc, { net_price, fst_quantity }) => {
                        return (
                          acc +
                          net_price *
                            ((fst_quantity * 100) / getSummaries.TotalAdmits)
                        );
                      },
                      0
                    ).toFixed(MIN_FRACTION_DIGITS) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    PerformanceConcessionReports.FoodCategory.reduce(
                      (acc, { std_profit, fst_quantity }) => {
                        return (
                          acc +
                          std_profit *
                            ((fst_quantity * 100) / getSummaries.TotalAdmits)
                        );
                      },
                      0
                    ).toFixed(MIN_FRACTION_DIGITS) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    PerformanceConcessionReports.FoodCategory.reduce(
                      (acc, { net_sales }) => {
                        return acc + net_sales;
                      },
                      0
                    ).toFixed(MIN_FRACTION_DIGITS) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    PerformanceConcessionReports.FoodCategory.reduce(
                      (acc, { net_sales, total_net_sales }) => {
                        return acc + (net_sales / total_net_sales) * 100;
                      },
                      0
                    ).toFixed(MIN_FRACTION_DIGITS) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    PerformanceConcessionReports.FoodCategory.reduce(
                      (acc, { net_profit }) => {
                        return acc + net_profit;
                      },
                      0
                    ).toFixed(MIN_FRACTION_DIGITS) || 0.0
                  }}
                </td>
                <td class="text-right">
                  {{
                    PerformanceConcessionReports.FoodCategory.reduce(
                      (acc, { net_profit, total_std_profit }) => {
                        return acc + (net_profit / total_std_profit) * 100;
                      },
                      0
                    ).toFixed(MIN_FRACTION_DIGITS) || 0.0
                  }}
                </td>
              </tr>
            </tbody>
            <tbody class="border-bottom border-dark">
              <tr class="bg-lightgrey font-weight-bold">
                <td>
                  <strong>F&amp;B Total</strong>
                </td>

                <td class="text-right">
                  <strong>{{ getPerformanceRecordsTotal.qtySold }}</strong>
                </td>
                <td class="text-right">
                  <strong>{{
                    currFormat(getPerformanceRecordsTotal.netPrice)
                  }}</strong>
                </td>
                <td class="text-right">
                  <strong>{{
                    currFormat(getPerformanceRecordsTotal.stdProfit)
                  }}</strong>
                </td>

                <td class="text-right">
                  <strong>{{
                    currFormat(getPerformanceRecordsTotal.stdProfitPercentage)
                  }}</strong>
                </td>
                <td class="text-right">
                  {{ currFormat(getPerPatronsTotal.qtyTotal) }}
                </td>
                <td class="text-right">
                  {{ currFormat(getPerPatronsTotal.salesTotal) }}
                </td>
                <td class="text-right">
                  {{ currFormat(getPerPatronsTotal.profitTotal) }}
                </td>
                <td class="text-right">
                  <strong>{{
                    currFormat(getPerformanceRecordsTotal.netSale)
                  }}</strong>
                </td>
                <td class="text-right">
                  <strong>{{
                    currFormat(getPerformanceRecordsTotal.saleMix)
                  }}</strong>
                </td>
                <td class="text-right">
                  <strong>{{
                    currFormat(getPerformanceRecordsTotal.netProfit)
                  }}</strong>
                </td>
                <td class="text-right">
                  <strong>{{
                    currFormat(getPerformanceRecordsTotal.profitMix)
                  }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import MasterService from "@/services/MasterService";
  import { Role, CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";
  import { mapState, mapGetters, mapActions } from "vuex";
  import { BASEURL } from "@/config/index";
  import xlsx from "json-as-xlsx";
  import NoRecords from "@/components/Partials/NoRecords.vue";

  export default {
    components: {
      NoRecords,
    },
    data() {
      return {
        BASEURL,
        Cinemas: [],
        CinemasCopy: [],
        searchCinema: "",
        selected_version: "v1",
        taxTotalObj: {},
        tablesList: ["Performance Report", "Summary Report", "Both"],
        selectedTable: "Both",
        patronsTotal: {
          qtyTotal: 0,
          salesTotal: 0,
          profitTotal: 0,
        },
        selectTableList: {
          performanceReport: true,
          summaryReport: true,
        },
      };
    },
    computed: {
      isIraq() {
        console.log("DBHDBVHBVHDBV", this.CLIENT_SETUP_NAME);
        return CLIENT_NAME.IRAQ == this.CLIENT_SETUP_NAME;
      },
      isStar() {
        return CLIENT_NAME.STAR == this.CLIENT_SETUP_NAME;
      },
      IsTaxSplitShow() {
        return CLIENT_NAMES_OBJ.performance_report_combo.includes(
          this.CLIENT_SETUP_NAME
        );
      },
      ...mapGetters([
        // Flags
        "getPerformanceReportsIsCinema",
        // End
        // Get Only
        "getCinemasList",
        "getSummaryReportsIsCinema",
        //
        "getPerformanceReportChargeList",
        "getPerformanceReportList",

        "getPerformanceConcessionReportsList",
        "getPerformanceRecordsTotal",

        "getPerformanceReportToDate",
        "getPerformanceReportFromDate",
        "getPerformanceReportSelectedCinema",

        "getSummaries",
        "getSummariesBoxOffice",
        "getSummariesConcession",
        "getSummariesConcessionProfit",

        // EXCEL
        "getPerformanceExcelFileName",

        // PDF
        "getPerformancePdfFileName",
        "getSummariesPDFFileName",
      ]),

      getPerformanceConcessionReportsListSort() {
        let getperformancecategorysorted =
          this.getPerformanceConcessionReportsList &&
          this.getPerformanceConcessionReportsList.length
            ? _.orderBy(this.getPerformanceConcessionReportsList, (i) =>
                String(i.fc_category).trim()
              )
            : [];

        // getperformancecategorysorted.sort(function(a, b) {
        //   return b.hasOwnProperty("availableInVendorRates") &&
        //     b.availableInVendorRates == "N"
        //     ? -1
        //     : 1;
        // });

        return getperformancecategorysorted;
      },

      getPerPatronsTotal() {
        if (this.getPerformanceConcessionReportsList.length) {
          this.getPerformanceConcessionReportsList.map((x) => {
            if (x.FoodCategory.length) {
              x.FoodCategory.map((y) => {
                this.patronsTotal["qtyTotal"] += +parseFloat(
                  (y.fst_quantity * 100) /
                    parseFloat(this.getSummaries.TotalAdmits)
                );
                this.patronsTotal["salesTotal"] += +parseFloat(
                  (y.net_price_conv * (y.fst_quantity * 100)) /
                    parseFloat(this.getSummaries.TotalAdmits)
                );
                this.patronsTotal["profitTotal"] += +parseFloat(
                  (y.std_profit_conv * (y.fst_quantity * 100)) /
                    parseFloat(this.getSummaries.TotalAdmits)
                );
              });
            }
          });
        }
        return this.patronsTotal;
      },
    },
    watch: {
      "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
        if (CinemaObj) {
          this.onPerformanceReportDropdownHandler({
            event: null,
            name: "Cinema",
            selectedItem: CinemaObj,
          });
          this.onSummaryReportDropdownHandler({
            event: null,
            name: "isCinema",
            selectedItem: CinemaObj,
          });
        }
      },
    },
    beforeMount() {
      let cinemaId =
        this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO")["cinema_id"]
          ? this.secureStore.get("USINFO").cinema_id
          : null;

      this.getCinemaList(cinemaId);

      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      if (CinemaObj) {
        this.onPerformanceReportDropdownHandler({
          event: null,
          name: "Cinema",
          selectedItem: CinemaObj,
        });
        this.onSummaryReportDropdownHandler({
          event: null,
          name: "isCinema",
          selectedItem: CinemaObj,
        });
        this.submit();
      }
      // this.fetchCinemasList({cinemaId});
      // this.onPerformanceReportFlagHandler({
      //   event: null,
      //   name: "isCinema",
      //   value: cinemaId
      // });
      // this.onPerformanceReportFlagHandler({
      //   event: null,
      //   name: "isCountry",
      //   value: this.secureStore.get("BRGLOPCO") || null
      // });
    },
    mounted() {},
    methods: {
      excelDownload() {
        let temp_records = this.getPerformanceReportList;
        let temp_arr = this.getPerformanceReportList;
        temp_records.map((x) => {
          let obj = { ...x };
          obj["showTotal"] = this.getPerformanceReportList.reduce(
            (acc, { no_of_show }) => acc + no_of_show,
            0
          );
          obj["admitsTotal"] = this.getPerformanceReportList.reduce(
            (acc, { admits }) => acc + admits,
            0
          );
          obj["capacityTotal"] = this.getPerformanceReportList.reduce(
            (acc, { capacity_total }) => acc + capacity_total,
            0
          );
          obj["occupancyTotal"] = this.getPerformanceReportList.reduce(
            (acc, { capacity_total, admits, no_of_show }) =>
              acc +
              (parseFloat(admits) / parseFloat(capacity_total)) *
                parseFloat(no_of_show) *
                100,
            0
          );
          obj["BORTotal"] = this.getPerformanceReportList.reduce(
            (acc, { gross_amount }) => acc + gross_amount,
            0
          );
        });
        let data = [
          {
            sheet: "FilmWiseCollection Report",
            columns: [
              {
                value: "movie_name",
                label: "Movie Name",
              },
              {
                value: "no_of_show",
                label: "No of Show",
              },
              {
                value: "admits",
                label: "Admits",
              },
              {
                value: "capacity_total",
                label: "Screen Capacity",
              },
              {
                value: (row) =>
                  row.admits && row.capacity_total && row.no_of_show
                    ? parseFloat(
                        (row.admits / row.capacity_total) * 100
                      ).toFixed(2)
                    : 0,
                label: "Occupancy Percentage",
              },
              {
                value: "gross_amount",
                label: "BOR",
              },
              {
                value: (row) =>
                  parseFloat(row.GCAM).toFixed(this.MIN_FRACTION_DIGITS),
                label: "GCAM",
              },
              {
                value: (row) =>
                  parseFloat(row.VAT).toFixed(this.MIN_FRACTION_DIGITS),
                label: "VAT",
              },
              {
                value: (row) =>
                  parseFloat(
                    row.net_amount
                      ? row.net_amount.toFixed(this.MIN_FRACTION_DIGITS)
                      : 0.0
                  ),
                label: "Net BOR",
              },
              {
                value: (row) =>
                  row.gross_amount && row.admits
                    ? parseFloat(row.gross_amount / row.admits).toFixed(
                        this.MIN_FRACTION_DIGITS
                      )
                    : 0.0,
                label: "BOR ATP",
              },
              {
                value: (row) =>
                  row.net_amount && row.admits
                    ? parseFloat(row.net_amount / row.admits).toFixed(
                        this.MIN_FRACTION_DIGITS
                      )
                    : 0.0,
                label: "NET ATP",
              },

              //      Sold: 0,
              // gross_amount: 0,
              // offer_price: 0,
              // total_taxes: 0,
              // final_gross_amount: 0
            ],
            content: temp_arr,
          },
        ];
        let settings = {
          fileName: `Performance&SummaryReport${new Date().getTime()}`,
        };
        xlsx(data, settings);
      },
      concessionExcelDownload() {
        let temp_obj = this.getPerformanceConcessionReportsList;
        let temp_arr = [];
        temp_obj.map((x) => {
          x.FoodCategory.map((y) => {
            let obj = { ...x, ...y, ...this.getSummaries };
            temp_arr.push(obj);
          });
        });
        let data = [
          {
            sheet: "Concession Sales Report",
            columns: [
              {
                value: "item_name",
                label: "Item Name",
              },
              {
                value: "fst_quantity",
                label: "Qty Sold",
              },
              {
                value: (row) =>
                  row.net_price
                    ? +parseFloat(row.net_price).toFixed(
                        this.MIN_FRACTION_DIGITS
                      )
                    : "-",
                label: "Net Price",
              },
              {
                value: (row) =>
                  row.std_profit
                    ? +parseFloat(row.std_profit).toFixed(
                        this.MIN_FRACTION_DIGITS
                      )
                    : "-",
                label: "Std Profit",
              },

              {
                value: (row) =>
                  row.fst_quantity
                    ? +parseFloat(
                        (row.fst_quantity * 100) / row.TotalAdmits
                      ).toFixed(this.MIN_FRACTION_DIGITS)
                    : "-",
                label: "Qty Per 100 Patrons",
              },
              {
                value: (row) =>
                  row.net_price
                    ? +parseFloat(
                        row.net_price *
                          ((row.fst_quantity * 100) / row.TotalAdmits)
                      ).toFixed(this.MIN_FRACTION_DIGITS)
                    : "-",
                label: "Sales Per 100 Patrons",
              },
              {
                value: (row) =>
                  row.std_profit
                    ? +parseFloat(
                        row.std_profit *
                          ((row.fst_quantity * 100) / row.TotalAdmits)
                      ).toFixed(this.MIN_FRACTION_DIGITS)
                    : "-",
                label: "Profit Per 100 Patrons",
              },
              {
                value: (row) =>
                  row.std_profit && row.net_price
                    ? +parseFloat(
                        (row.std_profit / row.net_price) * 100
                      ).toFixed(2)
                    : 0,
                label: "Std Profit %",
              },
              {
                value: (row) =>
                  row.net_sales
                    ? +parseFloat(row.net_sales).toFixed(
                        this.MIN_FRACTION_DIGITS
                      )
                    : "-",
                label: "Net Sale",
              },
              {
                value: (row) =>
                  row.net_sales && row.total_net_sales
                    ? +parseFloat(
                        (row.net_sales / row.total_net_sales) * 100
                      ).toFixed(this.MIN_FRACTION_DIGITS)
                    : 0.0,
                label: "Sale Mix %",
              },
              {
                value: (row) =>
                  +parseFloat(row.net_profit).toFixed(this.MIN_FRACTION_DIGITS),
                label: "Net Profit",
              },
              {
                value: (row) =>
                  row.net_profit && row.total_std_profit
                    ? +parseFloat(
                        (+parseFloat(row.net_profit) /
                          +parseFloat(row.total_std_profit)) *
                          100
                      ).toFixed(this.MIN_FRACTION_DIGITS)
                    : 0.0,
                label: "Profit Mix %",
              },

              //      Sold: 0,
              // gross_amount: 0,
              // offer_price: 0,
              // total_taxes: 0,
              // final_gross_amount: 0
            ],
            content: temp_arr,
          },
        ];
        let settings = {
          fileName: `ConcessionReport${new Date().getTime()}`,
        };
        xlsx(data, settings);
      },
      getPerformanceReportV3() {
        let payload = {
          fromDate: "",
          toDate: "",
          cinema_id: "",
        };

        MasterService.getPerformanceReportAkil(payload).then((response) => {
          const { data } = response;

          if (data.status) {
          }
        });
      },
      onSelectCinema(cinema) {
        this.$store.dispatch("selectDropdownCinema", cinema);
      },
      onSearchCinema: function() {
        if (this.searchCinema && this.searchCinema.length > 0) {
          this.Cinemas = this.CinemasCopy.filter((x) => {
            if (
              x.cine_name
                .toLowerCase()
                .includes(this.searchCinema.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.Cinemas = this.CinemasCopy;
        }
      },
      getCinemaList: function(cine_id) {
        this.Cinemas = [];
        //  let payload = null
        //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
        MasterService.GetCinemasByRoles({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              this.CinemasCopy = data.Records;
              this.Cinemas.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  // let cinema = {
                  //   cine_name: x.cine_name,
                  //   cine_id: x.cine_id
                  // };

                  this.onPerformanceReportDropdownHandler({
                    name: "Cinema",
                    selectedItem: {
                      cine_name: x.cine_name,
                      cine_id: x.cine_id,
                    },
                  });
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      ...mapActions([
        "fetchPerformanceReportListV2",
        "fetchPerformanceReportListV2Akil",
        "onPerformanceReportDateHandlerV3Akil",
        "fetchCinemasList",
        "onPerformanceReportDropdownHandler",
        "onPerformanceReportFlagHandler",
        "onResetPerformanceReportStoreState",

        //
        "fetchSummaryReportList",
        "fetchCinemasList",
        //
        "onSummaryReportDateHandler",
        "onSummaryReportDropdownHandler",
        "onSummaryReportFlagHandler",
        "onResetSummaryStoreState",
      ]),
      submit() {
        if (!this.getPerformanceReportFromDate) {
          this.$toasted.show("Please select Dates.");
        } else {
          this.fetchPerformanceReportListV2Akil().then(() => {
            setTimeout(() => {
              this.getGrandTotal();
            }, 2000);
          });
          this.fetchSummaryReportList();
        }
      },
      getGrandTotal() {
        let tempObj = {};
        let tempTotal = this.getPerformanceReportList;
        this.getPerformanceReportChargeList.map((x) => {
          console.log("x", "from y");
          tempTotal.map((y) => {
            tempObj[x.ct_name] = tempObj[x.ct_name]
              ? +parseFloat(tempObj[x.ct_name]) + +parseFloat(y[x.ct_name])
              : 0 + +parseFloat(y[x.ct_name]);
            console.log(0 + y[x.ct_name]);
          });
        });
        return tempObj;
        console.log("tempObj", tempObj);
      },
    },
    beforeDestroy: async function() {
      await this.$store.dispatch("globalRemoveFile", {
        fileName: this.getPerformanceExcelFileName,
      });
      await this.onResetPerformanceReportStoreState();
      await this.$store.dispatch("globalRemoveFile", {
        fileName: this.getSummariesPDFFileName,
      });
      await this.onResetSummaryStoreState();
    },
  };
</script>

<style>
  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }

  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }

  .concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
  }

  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }

  .concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }

  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/performanceAndSummaryReport.vue